import './index.css';

function Foot() {
    return (
        <>
            <div className='footer'>rohitNegi59@gmail.com</div>

        </>
    );
}

export default  Foot;
